export default __webpack_public_path__ + "static/media/mysql.fdca2180.png";